<cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten">
  <ng-container title>
    <h2 class="mb-0">{{ "neskoab.AmtlicheBewertung" | translate }}</h2>
  </ng-container>
  @if (_awDetailEntry) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="neskoab.AmtlicherWert">
          @if (_awDetailEntry.isAmtlicherWertVerteilt) {
            <span> ({{ _awDetailEntry.amtlicherWert | betrag: true }}) 0 </span>
          }
          @if (!_awDetailEntry.isAmtlicherWertVerteilt) {
            <span>
              {{ _awDetailEntry.amtlicherWert | betrag: true }}
            </span>
          }
          @if (_awDetailEntry.isKennzeichnungErtragswert && _awDetailEntry.amtlicherWert && !_awDetailEntry.ertragswertNachBGBB) {
            <span>
              {{ "(mit Ertragswertkomponente)" | translate }}
            </span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="neskoab.ErtragswertBGBB">
          {{ _awDetailEntry.ertragswertNachBGBB | betrag: true }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="neskoab.GueltigAbSteuerjahr">
          {{ _awDetailEntry.gueltigAbSteuerjahr }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="neskoab.Totalflaeche"> {{ _awDetailEntry.flaeche | decimalHochkomma }}&nbsp;m² </cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="neskoab.Mutationsgrund">
          {{ _awDetailEntry.mutationsgrund | translate }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="neskoab.Mutationsdatum">
          {{ _awDetailEntry.mutationsDatum | datum }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="neskoab.BasisRevision">
          {{ _awDetailEntry.basisRevisionAw }}
        </cap-kopfdatenelement>
      </div>
    </div>
  }
  <cap-beschreibung-table-wrapper [tableFullWidth]="false">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Stammgrundstueck" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (listLoaderStammgrundstueck) {
        <cap-list-loader
          [defaultText]="'gemaessAmtlicherBewertung'"
          [hasRight]="hasRight"
          [listLoader]="listLoaderStammgrundstueck"
          [showTotal]="false">
          <div class="cap-list-loader-title">
            <ng-content select="[name=title]"></ng-content>
          </div>
          <div class="cap-list-loader-content">
            <table class="cap-table-detail">
              <thead>
                <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
              </thead>
              <tbody>
                <ng-template
                  [ngTemplateOutlet]="tableRows"
                  [ngTemplateOutletContext]="{ listLoaderGs: listLoaderStammgrundstueck }"></ng-template>
              </tbody>
            </table>
          </div>
        </cap-list-loader>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>

  <cap-beschreibung-table-wrapper [tableFullWidth]="false">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "DominierteGrundstuecke" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (listLoaderDominierteGs) {
        <cap-list-loader
          [defaultText]="'gemaessAmtlicherBewertung'"
          [hasRight]="hasRight"
          [listLoader]="listLoaderDominierteGs"
          [showTotal]="false">
          <div class="cap-list-loader-title">
            <ng-content select="[name=title]"></ng-content>
          </div>
          <div class="cap-list-loader-content">
            <table class="cap-table-detail">
              <thead>
                <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
              </thead>
              <tbody>
                <ng-template
                  [ngTemplateOutlet]="tableRows"
                  [ngTemplateOutletContext]="{ listLoaderGs: listLoaderDominierteGs }"></ng-template>
              </tbody>
            </table>
          </div>
        </cap-list-loader>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
  <ng-template #tableHeaders>
    <tr>
      <th>{{ "Grundstueck" | translate }}</th>
      <th>{{ "Anteil" | translate }}</th>
      <th>{{ "neskoab.AmtlicherWert" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template #tableRows let-listLoaderGs="listLoaderGs">
    @for (item of listLoaderGs?.items; track item) {
      <tr>
        <td>
          <cap-kompakt-neskoab-grundstueck [item]="item"></cap-kompakt-neskoab-grundstueck>
        </td>
        <td>{{ item.anteilZaehler | decimalHochkomma }}/{{ item.anteilNenner | decimalHochkomma }}</td>
        <td>
          {{ item.amtlicherWert | betrag: true }}
        </td>
      </tr>
    }
  </ng-template>
</cap-rubrik>
